// Ensure 'subscribe' and 'publish' functions are available

if (!customElements.get('sub-widget')) {
  customElements.define(
    'sub-widget',
    class SubWidget extends HTMLElement {
      constructor() {
        super();
        this.queryParam = this.dataset.queryParam || 'sub'; // Get 'sub' from data-query-param
        this.inputs = this.querySelectorAll('input[name="selling_plan"]');
      }

      connectedCallback() {
        this.selectedSellingPlanId = null;
        this.popup = this.querySelector('.selling-plan__richtext');
        this.quantityInput = document.querySelector('input[name="quantity"]');
        this.allCards = this.querySelectorAll('.sub-wid__card');
        this.subscriptionProductCheckbox = this.querySelector('.sub-wid__subscription-product-checkbox');
        this.sellingPlanInput = document.querySelector('.selected-selling-plan-id'); // Assuming this input exists

        // 1. Initial preselection from URL
        this.initialSelect();
        
        // 2. Add event listeners
        this.addEventListeners();

        // logic for changing labels (left unchanged)
        this.enableLabels = this.dataset.enableLabels;
        if(this.enableLabels) {
          subscribe(PUB_SUB_EVENTS.quantityVariantChange, (event) => {  
            const quantityDataIndex = event.data.quantityDataIndex;
            this.allCards.forEach((card, index) => {
              const cardDescription = card.querySelector('.sub-wid__card-description');
              if(!cardDescription) return;
              // Note: There must be an offset here because the "Jednorazowo" (One-time) radio (index 0) has no description.
              // Assuming descriptions are only in subscriptions, which start from index 1.
              if(index === parseInt(quantityDataIndex)) { // radio indexes start from 0, but plans too
                cardDescription.classList.remove('hidden');
              } else {
                cardDescription.classList.add('hidden');
              }
            });
          });
        }
      }

      addEventListeners() {
        this.inputs?.forEach((input) => {
          input.addEventListener('change', (event) => {
            // Your widget logic:
            this.handleWidgetChange(event); 
            // 3. URL Synchronization
            this.updateUrl(event.target.value);
          });
        });
      }
      
      /**
       * Method for handling widget change logic (moved from connectedCallback)
       * This runs on user click and on initial selection from URL.
       */
      handleWidgetChange(event) {
          this.selectedSellingPlanId = event.target.value;
          
          // We use event.target.value instead of this.sellingPlanInput.value here, 
          // because this is the value we want to pass. If you sell via /cart/add.js,
          // the selling_plan ID is needed in the request body.
          
          // HERE: If you use a hidden input to store the ID, update it:
          if(this.sellingPlanInput) {
            this.sellingPlanInput.value = this.selectedSellingPlanId;
          }

          const singlePaymentImage = document.querySelector('.payment-image-single-time-payment');
          const subscriptionPaymentImage = document.querySelector('.payment-image-subscription');
          
          if (event.target.value !== '') { // Subscription selected (value is selling_plan ID)
            singlePaymentImage.style.display = 'none';
            subscriptionPaymentImage.style.display = 'block';
            this.popup.classList.remove('hidden');

            publish(PUB_SUB_EVENTS.addImageToGallerySlider, {
              blockId: this.dataset.blockId,
              imageUrl: this.dataset.sliderImage,
            });

            // enable subscription product checkbox
            this.subscriptionProductCheckbox?.removeAttribute('disabled');
            this.subscriptionProductCheckbox?.setAttribute('checked', '');

          } else { // One-time selected (value is "")
            singlePaymentImage.style.display = 'block';
            subscriptionPaymentImage.style.display = 'none';
            this.popup.classList.add('hidden');
            
            // disable subscription product checkbox
            this.subscriptionProductCheckbox?.setAttribute('disabled', '');
            this.subscriptionProductCheckbox?.removeAttribute('checked');
            
            publish(PUB_SUB_EVENTS.removeImageFromGallerySlider, {
              blockId: this.dataset.blockId,
              imageUrl: this.dataset.sliderImage,
            });
          }

          publish(PUB_SUB_EVENTS.sellingPlanChange, {
            data: {
              sellingPlanId: this.selectedSellingPlanId,
            },
          });
      }
      
      /**
       * Initial selection based on the URL parameter.
       * Defaults to the "Jednorazowo" (One-time) option (value="").
       */
      initialSelect() {
        const urlParams = new URLSearchParams(window.location.search);
        let urlValue = urlParams.get(this.queryParam); // e.g., plan ID

        // Default value is "Jednorazowo" (value="")
        if (!urlValue) {
          urlValue = ''; 
        }

        const targetInput = Array.from(this.inputs).find(
          (input) => input.value === urlValue
        );

        if (targetInput) {
          // Check the radio input
          targetInput.checked = true;
          
          // Run widget logic for the pre-selected option (important for visual updates!)
          this.handleWidgetChange({ target: targetInput });
        }
      }

      /**
       * Updates the URL parameter without reloading the page.
       * @param {string} value - The new parameter value (plan ID or empty string for one-time).
       */
      updateUrl(value) {
        const url = new URL(window.location.href);
        
        // Default value is 'one-time', which is value=''.
        const defaultValue = '';

        if (value && value !== defaultValue) {
          // Set the plan ID in the URL
          url.searchParams.set(this.queryParam, value);
        } else {
          // Remove the parameter if the default option ('') is selected
          url.searchParams.delete(this.queryParam);
        }

        window.history.replaceState({}, '', url.toString());
      }
    }
  );
}